import { useSetAtom } from 'jotai/index';

import { CaregiverCallConfirmationType } from '@/shared/call/CaregiverCallConfirmationType';

import { makeCallAtom } from '../model/store';
import { useCaregiverCallConfirmationBase } from './useCaregiverCallConfirmationBase';

type UseCaregiverVideoCallConfirmationProps = {
    consultationUid: string;
    onClose: () => void;
};

export const useCaregiverVideoCallConfirmation = ({
    consultationUid,
    onClose,
}: UseCaregiverVideoCallConfirmationProps) => {
    const makeCall = useSetAtom(makeCallAtom);

    const baseResult = useCaregiverCallConfirmationBase({
        confirmationType: CaregiverCallConfirmationType.video,
        consultationUid,
        onClose,
    });

    return {
        ...baseResult,
        makeCall,
    };
};
